import React, { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';
import Navbar from '../components/Navbar';
import '../Global.css';
import { useNavigate } from "react-router-dom";
import api from '../api';
export default function ChatTest() {
    // --- AYAR STATE'LERİ ---
    const [token, setToken] = useState(localStorage.getItem('JWTTOKEN'));
    const [userId, setUserId] = useState("6a3ee3bbeec2ca20c736511c"); // Socket query için
    const [myUsername, setMyUsername] = useState("whitedurna");
    const [receiverUsername, setReceiverUsername] = useState("okuz");
    const [matchId, setMatchId] = useState("6a35a4e88f4055285837326d");

    // --- UYGULAMA STATE'LERİ ---
    const [socket, setSocket] = useState(null);
    const [isConnected, setIsConnected] = useState(false);
    const [messages, setMessages] = useState([]);
    const [inputText, setInputText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    console.log("isConnected:",isConnected);
    const messagesEndRef = useRef(null);

    // Otomatik aşağı kaydırma
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    // Bağlantıyı Başlat
    const handleConnect = async () => {
        if (!token || !userId || !myUsername || !matchId) {
            alert("Lütfen tüm ayar alanlarını doldurun!");
            return;
        }

        // 1. Eski mesajları çek
        setIsLoading(true);
        try {
            const response = await api.get(`v1/chat/${matchId}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessages(response.data);
        } catch (error) {
            console.error("Eski mesajlar çekilemedi:", error);
            alert("API Hatası (CORS veya Token geçersiz olabilir). Konsola bak.");
        } finally {
            setIsLoading(false);
        }

        // 2. Socket Bağlantısını Kur
        const newSocket = io("https://socket.turnaments.com", {
            transports: ['websocket'],
            auth:{token}
        });

        newSocket.on("connect", () => {
            setIsConnected(true);
            newSocket.emit("join_room", matchId);

            newSocket.emit("mark_as_read", {
                matchId: matchId,
                username: myUsername
            });
        });

        newSocket.on("receive_message", (newMessage) => {
            console.log("Yeni mesaj geldi:", newMessage);
            setMessages((prev) => [...prev, newMessage]);

            if (newMessage.sender !== myUsername) {
                newSocket.emit("mark_as_read", {
                    matchId: matchId,
                    username: myUsername
                });
            }
        });

        newSocket.on("messages_read_by_user", (data) => {
            console.log("Karşı taraf mesajları okudu:", data);

            // Ekranda (state'te) bize ait olan mesajların isRead değerini true (mavi tık) yapıyoruz.
            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    // Eğer mesajın göndericisi bensem ve henüz okundu görünmüyorsa true yap
                    msg.sender === myUsername ? { ...msg, isRead: true } : msg
                )
            );
        });

        setSocket(newSocket);
    };

    // Bağlantıyı Kes
    const handleDisconnect = () => {
        if (socket) {
            socket.emit("leave_room", matchId);
            socket.disconnect();
        }
        setSocket(null);
        setIsConnected(false);
        setMessages([]);
    };

    // Mesaj Gönder
    const sendMessage = () => {
        if (inputText.trim() === "" || !socket) return;

        const newMessage = {
            id: Date.now().toString(),
            text: inputText,
            sender: myUsername,
            reciever: receiverUsername, // RN kodundaki yazım şeklini koruduk
            matchId: matchId,
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        };

        socket.emit("send_message", newMessage);

        // Test aracında gönderdiğimiz mesajı manuel olarak listeye ekleyebiliriz (veya backend geri dönüyorsa bekleyebiliriz)
        setMessages((prev) => [...prev, { ...newMessage, _id: newMessage.id, createdAt: new Date().toISOString() }]);
        setInputText("");
    };

    return (
        <div className="app-container">
            <Navbar />

            <div className="main-content">
                <div style={styles.container}>
                    <div style={styles.sidebar}>
                        <h2 style={{ color: 'white', marginBottom: '20px' }}>🔧 Test Ayarları</h2>

                        {/* JWT Token Input */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ color: 'lightgray', display: 'block', marginBottom: '5px', fontSize: '14px' }}>JWT Token:</label>
                            <input style={styles.input} placeholder="Token değerini girin..." value={token} onChange={e => setToken(e.target.value)} disabled={isConnected} />
                        </div>

                        {/* User ID Input */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ color: 'lightgray', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Benim User ID'm:</label>
                            <input style={styles.input} placeholder="Kendi ID'niz..." value={userId} onChange={e => setUserId(e.target.value)} disabled={isConnected} />
                        </div>

                        {/* My Username Input */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ color: 'lightgray', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Benim Kullanıcı Adım:</label>
                            <input style={styles.input} placeholder="Kendi kullanıcı adınız..." value={myUsername} onChange={e => setMyUsername(e.target.value)} disabled={isConnected} />
                        </div>

                        {/* Receiver Username Input */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ color: 'lightgray', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Karşı Tarafın Kullanıcı Adı:</label>
                            <input style={styles.input} placeholder="Alıcının kullanıcı adı..." value={receiverUsername} onChange={e => setReceiverUsername(e.target.value)} disabled={isConnected} />
                        </div>

                        {/* Match ID Input */}
                        <div style={{ marginBottom: '20px' }}>
                            <label style={{ color: 'lightgray', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Match ID:</label>
                            <input style={styles.input} placeholder="Eşleşme ID'si..." value={matchId} onChange={e => setMatchId(e.target.value)} disabled={isConnected} />
                        </div>

                        {/* Butonlar */}
                        {!isConnected ? (
                            <button style={styles.btnSuccess} onClick={handleConnect}>Sisteme Bağlan</button>
                        ) : (
                            <button style={styles.btnDanger} onClick={handleDisconnect}>Bağlantıyı Kes</button>
                        )}
                    </div>

                    <div style={styles.chatBox}>
                        <div style={styles.header}>
                            <h3>Sohbet Test Ekranı (Durum: {isConnected ? "🟢 Bağlı" : "🔴 Koptu"})</h3>
                        </div>

                        <div style={styles.messagesContainer}>
                            {isLoading ? <p style={{ color: 'white' }}>Mesajlar yükleniyor...</p> : null}
                            {messages.map((msg, index) => {
                                const isMe = msg.sender === myUsername;
                                return (
                                    <div key={index} style={{ ...styles.messageWrapper, justifyContent: isMe ? "flex-end" : "flex-start" }}>
                                        <div style={{ ...styles.bubble, backgroundColor: isMe ? "#029220" : "#2A2A2A" }}>
                                            <span style={styles.senderName}>{msg.sender}</span>
                                            <div>{msg.text}</div>
                                        </div>
                                    </div>
                                );
                            })}
                            <div ref={messagesEndRef} />
                        </div>

                        <div style={styles.inputArea}>
                            <input
                                style={styles.chatInput}
                                placeholder="Mesajınızı yazın..."
                                value={inputText}
                                onChange={e => setInputText(e.target.value)}
                                onKeyDown={e => e.key === 'Enter' && sendMessage()}
                                disabled={!isConnected}
                            />
                            <button style={styles.sendBtn} onClick={sendMessage} disabled={!isConnected}>Gönder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

// Basit içi stiller (Kopyalaması kolay olsun diye CSS dosyası yerine buraya yazdım)
const styles = {
    container: { display: "flex", height: "100vh", backgroundColor: "#121212", fontFamily: "sans-serif" },
    sidebar: { width: "300px", padding: "20px", backgroundColor: "#1E1E1E", borderRight: "1px solid #2A2A2A", display: "flex", flexDirection: "column", gap: "10px" },
    input: { padding: "10px", borderRadius: "5px", border: "1px solid #333", backgroundColor: "#2A2A2A", color: "white" },
    btnSuccess: { padding: "10px", backgroundColor: "#029220", color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" },
    btnDanger: { padding: "10px", backgroundColor: "#FF4444", color: "white", border: "none", borderRadius: "5px", cursor: "pointer", fontWeight: "bold" },
    chatBox: { flex: 1, display: "flex", flexDirection: "column" },
    header: { padding: "15px", backgroundColor: "#1E1E1E", color: "white", borderBottom: "1px solid #2A2A2A" },
    messagesContainer: { flex: 1, padding: "20px", overflowY: "auto", display: "flex", flexDirection: "column", gap: "10px" },
    messageWrapper: { display: "flex", width: "100%" },
    bubble: { padding: "10px 15px", borderRadius: "10px", color: "white", maxWidth: "60%" },
    senderName: { fontSize: "0.8em", opacity: 0.6, marginBottom: "5px", display: "block" },
    inputArea: { padding: "15px", backgroundColor: "#1E1E1E", display: "flex", gap: "10px" },
    chatInput: { flex: 1, padding: "10px", borderRadius: "20px", border: "none", backgroundColor: "#2A2A2A", color: "white", outline: "none" },
    sendBtn: { padding: "10px 20px", backgroundColor: "#029220", color: "white", border: "none", borderRadius: "20px", cursor: "pointer" }
};